(function() { window.GUID_ddcaec88_4eb6_4803_9b07_db19c2ce6dd3 = { getGuid: function() { return "ddcaec88-4eb6-4803-9b07-db19c2ce6dd3"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: 'body',
                        childSelector: '.accordion-registrationstatus',
                        callback: function (control, e) {
                            control.$Container.offon('click.schedule-type', '.tab-menu-item', function (e) {
                                e.stopImmediatePropagation();
                                e.preventDefault();
                                let $this = $(this);
                                $this.addClass("is-highlighted");
                                $this.siblings().removeClass("is-highlighted");
                                control.Data.RefreshUrl = $this.attr('href');
                                control.RefreshContent();
                            });
                        }
                    });
                    CS.Controls.Button.Events.Clicked({
                        selector: 'body',
                        childSelector: '#button-show-filled-up',
                        callback: function (control, e) {
                            console.log('show full');
                            $('#button-show-filled-up').slideUp();
                            $('.group-time.full').slideDown();
                            $('.division-element.full').slideDown();
                        }
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=registration-status.js.map
